<div class="c-banner">
  <img src="{{info.image}}" alt="{{info.alt}}">
</div>